import { Text } from "@solomon-labs/design/components/ui";
import React from "react";

import { ListItem } from "../../../components/Data/List";

import { IconButton } from "./IconButton";

export interface AddressRowProps {
    /** The wallet address shown in the row body. */
    address: string;
    /** Detach this address from the list. */
    onRemove: () => void;
}

/**
 * AddressRow — one wallet address in the access-control list. A Domain
 * Component that wraps the `ListItem` GC: the address fills the body, a
 * "Remove" affordance fills the `trailing` slot.
 *
 * Visual no-op preservation: this list is a flat, borderless, non-selectable
 * address list, so the row suppresses `ListItem`'s border + hover chrome and
 * drops its default padding.
 */
export function AddressRow({
    address,
    onRemove
}: AddressRowProps): React.ReactElement {
    return (
        <ListItem
            itemKey={address}
            padding=""
            gap="gap-3"
            borderColor="transparent"
            hoverFillColor="transparent"
            hoverLineColor="transparent"
            trailing={
                <IconButton onClick={onRemove}>
                    <Text variant="fine-print" render={<span />}>
                        Remove
                    </Text>
                </IconButton>
            }
        >
            <Text
                variant="fine-print"
                render={<span />}
                className="text-foreground-neutral font-numeric truncate"
            >
                {address}
            </Text>
        </ListItem>
    );
}
